/* TetBoard  - by Matthew Vecchio / ReadyWolf 
 * a tetris like board grid
 *
 *
 *  
 * 
 *  
 */

import Phaser from 'phaser'
import { gSettings } from "../settings/gamesettings.js";
import * as mJS from  '../common/mvUtils.js'

class Button {
	constructor(phaserClass, x, y, label, scene, callback) {
		const button = phaserClass.add.text(x, y, label)
			.setOrigin(0.5)
			.setPadding(10)
			.setFont('stickieFont')
			.setFontSize(20)
			.setStyle({ backgroundColor: '#cdbaa9',color:'#930072' })
			.setInteractive({ useHandCursor: true })
			.on('pointerdown', () => { callback(); }) 
			.on('pointerover', () => button.setStyle({ fill: '#24ba94' }))
			.on('pointerout', () => button.setStyle({ fill: '#930072',  shadow: '10px 10px' }));
	}
}






export default class ratUI  {



	BG = 0;
    BGtemp = 0;
	TopScoreTxt = 0;
	TopScoreTxtVal = 0;
	YourScoreTxt = 0;
	YourScoreTxtVal = 0;
	LevelTxt = 0;
	LevelTxtVal = 0;
	HomedTxt = 0;
	HomedTxtVal = 0;
	RatText = 0;
	NextText = 0;
	RatImg = 0;

	RatBonusNumTxt = 0;
	RatBonusSavedTxt = 0;
	RatBonusScoreTxt = 0;

	ButtonUIString = [];

	TitlePanel = 0;
	TitleLogo = 0;
	TitleTxt = 0 
	HelpPanel = 0;
	LogoImg = 0;



	TreeImg = 0;
	HelpImg  = 0;

	GameOverLogo = 0;

	TitleState = 0;
	StartGameText = 0;
	inited = false;
	waitTime = 0;
	movementSpeed = 10;
    constructor() { 
    

    }


	updateUIButtonStr (string) {

		//this.ButtonUIString.push(string);
		//console.log(ButtonUIString + string)
		console.log("HELLO");
	}
	
	updateUIButtonStr () {
		//return ButtonUIString;
	}
	
	
	

    create(phaserClass) {
        this.BG =       phaserClass.add.image(0, 0, 'RatBG.gfx');
        this.BG.setOrigin(0, 0);
/*
        this.BGtemp =       phaserClass.add.image(0, 0, 'UITemp.gfx');
        this.BGtemp.setOrigin(0, 0);

        this.BGtemp.alpha = 0.5;
*/


/*
		this.startButton = phaserClass.add.text(scene.cameras.main.centerX, scene.cameras.main.centerY, 'Start game', textStyle)
			.setOrigin(0.5)
			.setPadding(10)
			.setStyle({ backgroundColor: '#111' })
			.setInteractive({ useHandCursor: true })
			.on('pointerdown', startGame)
			.on('pointerover', () => startButton.setStyle({ fill: '#f39c12' }))
			.on('pointerout', () => startButton.setStyle({ fill: '#FFF' }))
*/
		this.TitlePanel = phaserClass.add.image(gSettings.GRID_X_POS,gSettings.GRID_Y_POS,'SlidePanel.gfx');
		this.TitlePanel.setOrigin(0,0);
		this.TitlePanel.setTint(0x303030);
		this.TitlePanel.depth = 140;

		this.TitleLogo = phaserClass.add.image(gSettings.GRID_X_POS + 190, (gSettings.GRID_Y_POS + 150), 'RatLogo.gfx');
		this.TitleLogo.setOrigin(0.5,0.5);
		this.TitleLogo.alpha = 0;
		this.TitleLogo.depth = 150;


		this.GameOverLogo =  phaserClass.add.image(gSettings.GRID_X_POS + 190, (gSettings.GRID_Y_POS + 150), 'GameOver.gfx');
		this.GameOverLogo.setOrigin(0.5,0.5);
		this.GameOverLogo.alpha = 0;
		this.GameOverLogo.depth = 150;

		var textConfig = {fontFamily:'stickieFont',	fontSize:20, color:'#cdbaa9' }
	
		this.TitleTxt = phaserClass.add.text(315,310,'A Game About Nesting Wopolikaras\n\n                  How To Play:\n\nWopolikaras roam freely and nest\nin gaps.\n\nClear lines with nested wopolikaras\nto score.\n\n                     Controls:\n\nArrows 	:   Move Piece\nZ            :   Rotate Counter Clockwise\nX            :   Rotate Clockwise\nC            :   Soft Drop\nSpace    :   Hard Drop\n\n\n             Press Button To Play',textConfig);
		this.TitleTxt.alpha = 0;
		this.TitleTxt.depth = 150;
		var textConfig = {fontFamily:'stickieFont',	fontSize:40, color:'#30b9c1' }
	
		this.TopScoreTxt = phaserClass.add.text(35,20,'TOP SCORE',textConfig);

		textConfig = { fontFamily:'stickieFont', fontSize:40, color:'#cdbaa9' }

		this.TopScoreTxtVal = phaserClass.add.text(85,65,'0',textConfig);

		textConfig = { fontFamily:'stickieFont', fontSize:40, color:'#dab550' }

		this.YourScoreTxt = phaserClass.add.text(30,165,'YOUR SCORE',textConfig);
		
		textConfig = {	fontFamily:'stickieFont',	fontSize:40,	color:'#cdbaa9'	}
		



		this.YourScoreTxtVal = phaserClass.add.text(85,210,'0',textConfig);

		textConfig = { fontFamily:'stickieFont', fontSize:40, color:'#24ba94' }

		this.LevelTxt = phaserClass.add.text(85,300,'LEVEL',textConfig);
		
		textConfig = {	fontFamily:'stickieFont',	fontSize:40,	color:'#cdbaa9'	}
		
		this.LevelTxtVal = phaserClass.add.text(135,345,'0',textConfig);

		textConfig = {	fontFamily:'stickieFont',	fontSize:40,	color:'#930072'	}

		this.HomedTxt = phaserClass.add.text(80,420,"HOMED",textConfig);
		
		textConfig = {	fontFamily:'stickieFont',	fontSize:40,	color:'#cdbaa9'	}
		
		this.HomedTxtVal = phaserClass.add.text(135,460,'0',textConfig);
		
		textConfig = {	fontFamily:'stickieFont',	fontSize:40,	color:'#28862C'	}

		this.NextText = phaserClass.add.text(840,43,'NEXT',textConfig);

		textConfig = {	fontFamily:'stickieFont',	fontSize:130,	color:'#ffffff'	}

		this.RatBonusNumTxt = phaserClass.add.text(790,490, 6,textConfig);
		this.RatBonusNumTxt.setOrigin(0.5, 0.5);
		this.RatBonusNumTxt.alpha = 0;

		textConfig = {	fontFamily:'stickieFont',	fontSize:30,	color:'#cdbaa9'	}

		this.RatBonusSavedTxt = phaserClass.add.text(830,440, "Wopilkaras\n    saved",textConfig);
		this.RatBonusSavedTxt.alpha = 0;
		
		textConfig = {	fontFamily:'stickieFont',	fontSize:30,	color:'#ffffff'	}
		
		this.RatBonusScoreTxt =  phaserClass.add.text(880,540, "+1000 Points",textConfig);
		this.RatBonusScoreTxt.setOrigin(0.5, 0.5);
		this.RatBonusScoreTxt.alpha = 0;
		


		this.TreeImg = phaserClass.add.image(860, 180, 'UITree.gfx');
		this.TreeImg.dir = 0;
		this.TreeImg.dirAmount = 0.01;
		this.TreeImg.maxAng = 5;
		

		this.RatImg = phaserClass.add.image(860, 340, 'RatKara.gfx');
		this.RatImg.dir = 1;
		this.RatImg.dirAmount = 0.01;
		this.RatImg.maxAng = 5;
		this.RatImg.scale = 0.8;
		this.RatImg.alpha = 0;
	//	this.ButtonUIString.push(string);
    //	const RSbutton = new Button(phaserClass, 935, 25, 'Restart Game', this, () => this.ButtonUIString.push('RestartGame'));
	
		if (gSettings.TOUCH_CONTROLS) {

			const LeftButton = new Button(phaserClass, 80, 615, '\n Left \n       ', this, () => this.ButtonUIString.push('MoveLeft'));
			const RightButton = new Button(phaserClass, 215, 615, '\n Right\n       ', this, () => this.ButtonUIString.push('MoveRight'));

			const DropButton = new Button(phaserClass, 150, 710, '\n    Drop   \n           ', this, () => this.ButtonUIString.push('Drop'));
	

			const RotCCWButton = new Button(phaserClass, 780, 615, '\n Rotate \n  <    ', this, () => this.ButtonUIString.push('RotCCW'));
			const RotCWButton = new Button(phaserClass, 930, 615, '\n Rotate  \n    >  ', this, () => this.ButtonUIString.push('RotCW'));

			const HardButton = new Button(phaserClass, 850, 710, '            \n    Hard\n    Drop ', this, () => this.ButtonUIString.push('HardDrop'));
		}


	//updateUIButtonStr
		this.inited = true;
    }


	update(time) {
	    //console.log(this.ButtonUIString);

		if (this.TitleState == 0) {
			this.TitleLogo.alpha += 0.01;
			this.TitleTxt.alpha += 0.01;
			if (this.GameOverLogo.alpha > 0) {
			this.GameOverLogo.alpha -= 0.05;
			}
			if (	this.TitleLogo.alpha > 1) {

				this.TitleLogo.alpha =1;
				this.TitleState++;
				
			}
		}
		if (this.TitleState == 2) {
			this.GameOverLogo.alpha = 0;
			this.TitleLogo.alpha = 1;
			this.TitleTxt.alpha  = 1;
			this.TitleLogo.y -=  this.movementSpeed;
			this.TitleTxt.y -=   this.movementSpeed;
			this.TitlePanel.y -= this.movementSpeed;
			if (this.TitlePanel.y == -1000) {
				this.TitleState++;
			} 
		}

		// start game over
		if (this.TitleState == 4) {
			this.GameOverLogo.y = -500;
			this.TitleState++;
		}

		if (this.TitleState == 5) {
			this.GameOverLogo.y += this.movementSpeed;
			if (this.GameOverLogo.alpha < 1) {
			this.GameOverLogo.alpha += 0.02;
			}

			if (this.GameOverLogo.y >= gSettings.GRID_Y_POS + 252 ) {
				this.GameOverLogo.y = gSettings.GRID_Y_POS + 252;
				this.TitleState++;
			}
		}

		if (this.TitleState == 6) {

			this.TitlePanel.y += this.movementSpeed;

			if (this.TitlePanel.y >= gSettings.GRID_Y_POS  ) {
				this.TitlePanel.y = gSettings.GRID_Y_POS ;
				this.TitleState++;
				this.waitTime = time + 1000;
			}

		}

		if (this.TitleState == 7) {
			if (this.waitTime < time) {
				this.TitleState++;
			}
		}

		if (this.TitleState == 8) {

			this.TitleLogo.x =gSettings.GRID_X_POS + 190;
			this.TitleLogo.y = (gSettings.GRID_Y_POS + 150);
			this.TitleLogo.alpha = 0;
		
			this.TitleTxt.x = 315;
			this.TitleTxt.y = 310;
			this.TitleTxt.alpha = 0;

			this.TitleState = 0;
		
		}



		
		if (this.TreeImg.angle > this.TreeImg.maxAng ) {
			this.TreeImg.dir  = 0;
		}
		if (this.TreeImg.angle < -this.TreeImg.maxAng ) {
			this.TreeImg.dir  = 1;
		}

		if (this.TreeImg.dir == 0) {
			this.TreeImg.angle -=	this.TreeImg.dirAmount ;

		}
		if (this.TreeImg.dir == 1) {
			this.TreeImg.angle +=	this.TreeImg.dirAmount ;
			
		}

	//	this.RatBonusNumTxt.scale -= 0.01;
		this.RatImg.alpha -= 0.005;
		this.RatBonusNumTxt.alpha -= 0.005;
		this.RatBonusSavedTxt.alpha -= 0.005;
		this.RatBonusScoreTxt.alpha -= 0.005;

/*
		if (this.RatImg.angle > this.RatImg.maxAng ) {
			this.RatImg.dir  = 0;
		}
		if (this.RatImg.angle < -this.RatImg.maxAng ) {
			this.RatImg.dir  = 1;
		}

		if (this.RatImg.dir == 0) {
			this.RatImg.angle -=	this.RatImg.dirAmount ;

		}
		if (this.RatImg.dir == 1) {
			this.RatImg.angle +=	this.RatImg.dirAmount ;
			
		}
*/

		


	}


}